// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"Page_mainPage__3qvP3"};